import { format, parseISO } from "date-fns";

export const formatDate = (iso) => {
  try {
    return format(parseISO(iso), "MMM d, yyyy");
  } catch {
    return iso;
  }
};

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const addDaysIso = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

export const freshnessLabel = (c) => {
  if (c.status === "consumed") return "Consumed";
  if (c.status === "discarded") return "Discarded";
  if (c.days_until_expiry < 0) {
    const d = Math.abs(c.days_until_expiry);
    return d === 1 ? "Past best-by" : `Past best-by ${d}d`;
  }
  if (c.days_until_expiry === 0) return "Best by today";
  if (c.days_until_expiry === 1) return "Best by tomorrow";
  if (c.days_until_expiry <= 2) return `${c.days_until_expiry}d left`;
  return `Fresh · ${c.days_until_expiry}d left`;
};

export const isExpired = (c) =>
  c.status !== "consumed" && c.status !== "discarded" && (c.days_until_expiry ?? 0) < 0;

// "At risk" = less than 24h from crossing the best-by date (i.e. today). Gets a
// subtle static orange caution icon — NOT the red animated one (that's for
// already-past best-by).
export const isAtRisk = (c) =>
  c.status !== "consumed" && c.status !== "discarded" && c.days_until_expiry === 0;

// Encode a QFresh code as the canonical sticker URL. Anyone scanning the
// sticker without QFresh installed will at least land on the web app, log in,
// and end up on the same container page.
export const qrUrlFor = (code) => {
  if (!code) return "";
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/c/${code}`;
};

// Extract a bare QFresh code from raw scanned text. Accepts a bare code,
// the canonical sticker URL form, or arbitrary junk (returns null).
//
// Doing this client-side lets us send only safe path-segment characters to
// the backend (no percent-encoding needed), which sidesteps a class of
// proxy-related double-encoding bugs where CF/ingress re-escapes `%` chars.
export const extractQrCode = (raw) => {
  if (!raw) return null;
  const text = String(raw).trim();
  // URL form: capture the /c/CODE tail
  const urlMatch = text.match(/\/c\/([A-Za-z0-9][A-Za-z0-9_-]{3,39})(?:[/?#]|$)/);
  if (urlMatch) return urlMatch[1].toUpperCase();
  // Bare code form
  const bare = text.toUpperCase();
  if (/^[A-Z0-9][A-Z0-9_-]{3,39}$/.test(bare)) return bare;
  return null;
};

export const boxLabel = (c) =>
  c && c.box_number ? `Box ${c.box_number}` : null;

export const freshnessColors = (c) => {
  if (c.status === "consumed") return { bg: "#E8F0EA", fg: "#1F5566", border: "#8BC58A" };
  if (c.status === "discarded") return { bg: "#F9E6E0", fg: "#9C3E1D", border: "#D95D39" };
  if (c.days_until_expiry < 0) return { bg: "#FBE2DA", fg: "#8C2A0F", border: "#D95D39" };
  if (c.days_until_expiry <= 2) return { bg: "#FBEAE5", fg: "#B04A2A", border: "#E07A5F" };
  return { bg: "#E8F0EA", fg: "#1F5566", border: "#8BC58A" };
};

export const DIETARY_TAGS = [
  "high-protein",
  "low-carb",
  "gluten-free",
  "vegetarian",
  "vegan",
  "dairy-free",
  "keto",
];
